import React from 'react';
import styled from 'styled-components';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { APP } from 'appenv';

import BackgroundImg from 'assets/background.jpg';
import Background618Img from 'assets/background-618-plain.png';
import Background623Img from 'assets/background-lobby-623.png';
import Background711Img from 'assets/background-711.jpg';

import DesktopLobbyView from './DesktopLobbyView';
import MobileLobbyView from './MobileLobbyView';
import Background624Container from './templates/Background624Conatiner';

const backgroundImage = () => {
  switch (APP) {
    case 'polyu618':
      return Background618Img;
    case 'paloalto623':
      return Background623Img;
    case 'ms624':
      return '';
    case 'scmp711':
      return Background711Img;
    default:
      return BackgroundImg;
  }
};

const backgroundImageMobile = () => {
  switch (APP) {
    case 'polyu618':
      return Background618Img;
    default:
      return '';
  }
};

const RootContainer = styled.div`
  height: 100%;
  overflow: hidden;
  background: url(${backgroundImageMobile()});
  background-color: #F0F1F2;

  @media (min-width: 960px) {
    background: url(${backgroundImage()});
    background-position: ${({ bgPosition }) => (bgPosition)};
    background-repeat: no-repeat;
    background-size: 1440px auto;
  }

  @media (min-width: 1440px), (min-height: 960px) {
    background-size: cover;
  }
`;

const PageContentContainer = styled.div`
  min-width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
`;

const MainLobbyContainer = () => {
  const isDesktop = useMediaQuery('(min-width: 960px)');

  return (
    <RootContainer bgPosition={APP === 'paloalto623' ? 'left bottom' : 'center center'}>
      {
        APP === 'ms624' && isDesktop && (
          <Background624Container />
        )
      }
      <PageContentContainer>
        {
          isDesktop ? (
            <DesktopLobbyView />
          ) : (
            <MobileLobbyView />
          )
        }
      </PageContentContainer>
    </RootContainer>
  );
};

export default MainLobbyContainer;
